import { NwButton } from "@nawy/ui";
import ChevronIcon from "@/modules/common/components/ui-kit/icons/chevron";
import CircularCheckbox from "@/modules/common/components/ui-kit/inputs/circular-checkbox";
import { Menu, MenuItem, PopoverOrigin, useTheme } from "@mui/material";
import { useState } from "react";

interface MenuItem {
  label: string;
  action: () => void;
  checked?: boolean;
}

interface FilterMenuProps {
  buttonText?: string;
  menuItems: MenuItem[];
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}

const FilterMenu = ({
  buttonText,
  menuItems,
  transformOrigin,
  anchorOrigin,
}: FilterMenuProps) => {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (open) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <NwButton
        variant="outlined"
        color="secondary"
        onClick={handleClick}
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableElevation
        endIcon={<ChevronIcon />}
        sx={{
          width: "fit-content",
        }}
      >
        {buttonText}
      </NwButton>
      <Menu
        id="demo-customized-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={
          anchorOrigin ?? {
            vertical: "bottom",
            horizontal: "left",
          }
        }
        transformOrigin={
          transformOrigin ?? {
            vertical: "top",
            horizontal: "left",
          }
        }
        sx={{
          "& .MuiPaper-root": {
            "& .MuiMenu-list": {
              minWidth: "194px",
              borderRadius: theme.nawy.radius.lg,
              border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
            },
          },
        }}
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.label}
            onClick={item.action}
            disableRipple
            sx={{
              display: "flex",
              alignItems: "center",
              gap: theme.nawy.spacing.xs,
            }}
          >
            <CircularCheckbox
              variant="square"
              size={20}
              checked={item.checked ?? false}
            />
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FilterMenu;
